import React from "react";
import Input from "../Input";

const GlobalFilter = ({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) => {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  // Normalize Input onChange payload:
  // - shared Input sends either HTMLInputElement or a string (e.g. clearable)
  const normalizeNextValue = React.useCallback((target) => {
    if (typeof target === "string") return target;
    if (target && typeof target === "object" && "value" in target) {
      return target.value ?? "";
    }
    return "";
  }, []);

  // Debounced mode (default)
  React.useEffect(() => {
    if (!debounce) return; // handled in immediate mode below
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value, debounce, onChange]);

  return (
    <Input
      id="table-search"
      onChange={(e) => {
        const nextValue = normalizeNextValue(e);
        setValue(nextValue);

        // Immediate mode: call onChange directly on keystroke
        if (!debounce) {
          onChange(nextValue);
        }
      }}
      size="sm"
      placeholder="Search..."
      value={value}
      className="bg-white"
      {...props}
    />
  );
};

export default GlobalFilter;
